import { useState, useEffect, useCallback } from 'react';
import { api, getApiUrl } from '../utils/apiConfig';
import { getUserData } from '../utils/userUtils';

/** Account-scoped inventory. Late replies must not replace another account's channels. */
export const useEnabledChannels = (accountId, user) => {
  const scope = `${accountId || ''}:${user?.id || ''}`;
  const [result, setResult] = useState(null);
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    let cancelled = false;
    if (!accountId || !user?.id) {
      setResult({ scope, channels: user?.enabledChannels || {}, error: null, loading: false });
      return undefined;
    }
    setResult({ scope, channels: {}, error: null, loading: true });
    (async () => {
      try {
        const userId = getUserData()?.userId || user.id;
        const { data } = await api.get(getApiUrl(`/api/users/enabled-channels/${accountId}`), { params: { userId } });
        if (!cancelled) setResult({ scope, channels: data.enabledChannels || {}, error: null, loading: false });
      } catch (error) {
        if (!cancelled) setResult({ scope, channels: {}, error, loading: false });
      }
    })();
    return () => { cancelled = true; };
    // Fetch on identity/account change or explicit refresh, not every user-object render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountId, user?.id, revision]);
  const refetch = useCallback(() => setRevision((value) => value + 1), []);
  const current = result?.scope === scope ? result : null;
  return { enabledChannels: current?.channels || {}, isLoading: current?.loading ?? Boolean(accountId && user?.id), error: current?.error || null, refetch };
};
